import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'

import { fethUserById } from '../api/user.api'
import { User } from '../models'
import { usePortalQuery } from 'src/Libs/api'

type DataReturnType = [User | null, boolean]

export const useUserByIdData = (userId: number | undefined): DataReturnType => {
  const authFetch = useAuthFetchWithResponse()

  const fetchUserByIdQueryFn = async (): Promise<User | null> => {
    const { error, hasErrors, value } = await fethUserById(userId as number, authFetch)

    if (hasErrors) {
      throw error || new Error('An unexpected error occurred when fetching user')
    }

    return value
  }

  const { data, isLoading } = usePortalQuery({
    queryKey: ['users', userId],
    queryFn: fetchUserByIdQueryFn,
    enabled: !!userId,
  })

  return [data || null, isLoading]
}
